import Swiper from "swiper";

let swiperMain: Swiper | null = null; // Tillad både Swiper og null
let swiperThumbs: Swiper | null = null; // Tillad både Swiper og null

export function initializeSwiper() {
  // Opret thumbs-swiperen først
  swiperThumbs = new Swiper(".swiper-thumbs", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    threshold: 5,
    observer: true, // Aktiver observer for thumbs-swiperen
    observeParents: true, // Observer også forældre-elementer
  });

  // Opret hoved-swiperen med thumbs-egenskaben
  swiperMain = new Swiper(".swiper-main", {
    loop: true,
    pagination: {
      el: document.querySelector(".swiper-pagination") as HTMLElement,
      clickable: true,
    },
    observer: true, // Aktiver observer for hoved-swiperen
    observeParents: true, // Observer også forældre-elementer
    navigation: {
      nextEl: ".custom-swiper-button-next",
      prevEl: ".custom-swiper-button-prev",
    },
    thumbs: {
      swiper: swiperThumbs, // Brug thumbs-swiperen her
    },
  });

  // Tilføj klik-begivenhedslytter til thumbnails
  document
    .querySelectorAll(".swiper-thumbs .swiper-slide")
    .forEach((slide, index) => {
      slide.addEventListener("click", () => {
        if (swiperMain) {
          swiperMain.slideTo(index); // Skift hoved-swiperen til det tilsvarende slide
        }
      });
    });

  // Tilføj event listeners til navigationsknapperne
  const nextButton = document.querySelector(".custom-swiper-button-next");
  const prevButton = document.querySelector(".custom-swiper-button-prev");

  if (nextButton && swiperMain) {
    nextButton.addEventListener("click", () => {
      if (swiperMain) {
        swiperMain.slideNext();
      }
    });
  }

  if (prevButton && swiperMain) {
    prevButton.addEventListener("click", () => {
      if (swiperMain) {
        swiperMain.slidePrev();
      }
    });
  }
}

// Funktion til at ødelægge Swiper-instanserne
export function destroySwiper() {
  if (swiperMain) {
    swiperMain.destroy(true, true);
    swiperMain = null;
  }
  if (swiperThumbs) {
    swiperThumbs.destroy(true, true);
    swiperThumbs = null;
  }
}
